import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const deleteCustomerDraft = createAsyncThunk(
  "integrations/deleteCustomerDraft",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/delete_customer_draft?customer_id=${data.customer_id}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const errorText = await response.text();
          const errorObj = JSON.parse(errorText);
          errorMessage = errorObj.error || errorMessage;
        } catch (e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Failed deleting customer draft:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteCustomerDraftSlice = createSlice({
  name: "integrations",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    resetDeleteCustomerDraftState(state) {
      state.status = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomerDraft.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteCustomerDraft.fulfilled, (state, action) => {
        state.apiKey = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteCustomerDraft.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteCustomerDraftState } =
  deleteCustomerDraftSlice.actions;
export default deleteCustomerDraftSlice.reducer;
